import { FC } from "react";
import { useSelector } from "react-redux";
import { map, isEmpty } from "lodash-es";

import { Spacer } from "shared/layout";
import { Loader, Pager, Message, Button } from "shared/components";
import { IAPIState, ICardTheme, ITheme } from "shared/types";
import { copy } from "shared/assets";

import { VenueTeaser } from "Venues/components";
import { dataMetaSelector } from "Venues/state";
import { IVenue, VENUE_ACTIONS } from "Venues/types";
import { usePagination } from "Venues/utils";
import { IVenueSearchQuery } from "Bands/contexts";

interface VenueSearchResultsProps {
  venues: IVenue[];
  query: IVenueSearchQuery;
  handlePageChange: (page: number) => void;
  handleVenueClick: (venue: IVenue) => void;
}

export const VenueSearchResults: FC<VenueSearchResultsProps> = ({
  venues,
  query,
  handlePageChange,
  handleVenueClick,
}) => {
  const { api } = useSelector(dataMetaSelector(VENUE_ACTIONS.getSearchVenues));
  const pagination = usePagination(VENUE_ACTIONS.getSearchVenues);
  const { empty: emptyCopy, venueBlock } = copy;

  if (api?.status === IAPIState.pending) {
    return <Loader />;
  }
  if (!query.query && !query.country) {
    return <Message message={venueBlock.search.noSearchMessage} />;
  } else if (isEmpty(venues)) {
    return <Message message={emptyCopy} />;
  }

  return (
    <Spacer size="m" mobile={{ align: "center" }}>
      <Spacer size="s" data-testid="venue-search-results">
        {venues &&
          map(venues, (venue: IVenue) => (
            <VenueTeaser
              key={venue.id}
              theme={ICardTheme.secondary}
              showMoreInfo={false}
              openInNewTab
              {...venue}
            >
              <Button
                size="s"
                theme={ITheme.tertiary}
                onClick={() => handleVenueClick(venue)}
              >
                {copy.venueBlock.buttons.chooseVenue}
              </Button>
            </VenueTeaser>
          ))}
      </Spacer>
      <Pager {...pagination} onPageChange={handlePageChange} />
    </Spacer>
  );
};
